import { AppRoute } from './root';

export default AppRoute;
